import Vue from 'vue';

import Collection from '../components/collection.js';

new Vue({
    el: '#template-collection',

    delimiters: ['${', '}'],

    components: {
        Collection
    }
});